module.exports = __webpack_public_path__ + "img/nhom-hoc-lieu.78a60439.svg";